import React from 'react';
import { Link } from 'react-router-dom';
import EmptyCart from './EmptyCart';

const CartViewHeader = (props) => {
  return (
    <React.Fragment>
      {props.data.length !== 0 ? (
        <div>
          <div className="cart-header">
            <div className='font-20'>Shopping cart</div>
            <div>{props.data.length} {`item(s)`}</div>
          </div>
          <div className='cart-product'>
            {props.data.map(element => (
              <div className="mc-product" id={element.cart_id} key={element.cart_id}>
                {element.book_cover !== null ? (
                  <img alt="" src={`data:image/jpeg;base64,${element.book_cover}`} className="product-image" />
                ) : (
                  <img className="product-image" src="ElsevierStyleSheet/images/ElsevierImage.png" alt="" />
                )}
                <div className='font-16 product-details'>
                  {element.title}
                  <div>
                    <button type="button"
                      className="es-link colored pointer"
                      onClick={(event) => {
                        event.preventDefault();
                        props.deleteCartItem(element.cart_id, element.product_id);
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 128" height="24" width="14">
                        <path fill="#007398" d="M68.94 36.12L62                           29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
                      </svg>
                      &nbsp;<span className="text-black">Remove</span>
                    </button>
                  </div>
                </div>
                <div className='product-meta'>
                  <div><strong>Quantity&nbsp;:&nbsp;{element.quantity}</strong></div>
                  <div className='text-end'>₹&nbsp;{element.total_price}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="cart-footer">
            <div>Item total</div>
            <div className='font-20'>₹ {props.data.reduce((sum, element) => sum + element.subtotal, 0)}</div>
          </div>
          <div className="es-header-buttons">
            <Link className="es-button primary w-100 text-center" to="/shoppingCart">
              <span>View Cart</span>
              <svg focusable="false" height="24" viewBox="0 0 54 128" width="11">
                <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
              </svg>
            </Link>
          </div>
        </div>
      ) : (
        <EmptyCart />
      )}
    </React.Fragment>
  );
};

export default CartViewHeader;